'use strict';

var styled = require('styled-components');
var breakpoints = require('../../theme/breakpoints.js');
require('react');
require('../../helpers/css-units.js');
require('../../theme/theme.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const getXGap = (theme, columnGap) => {
    if (columnGap) {
        const space = parseFloat(theme.space.component.x[columnGap]);
        if (space) {
            return `${space / 2}rem`;
        }
    }
    return 0;
};
const getYGap = (theme, rowGap) => {
    if (rowGap) {
        const space = parseFloat(theme.space.component.y[rowGap]);
        if (space) {
            return `${space / 2}rem`;
        }
    }
    return 0;
};
const StyledWrapper = styled__default.default.div `
  display: flex;
  flex-wrap: wrap;
  ${({ alignItems }) => (alignItems ? `align-items: ${alignItems};` : null)}
  ${({ justifyContent }) => (justifyContent ? `justify-content: ${justifyContent};` : null)}
  margin: ${({ theme, columnGap, rowGap }) => `-${getYGap(theme, rowGap)} -${getXGap(theme, columnGap)}`};
  > * {
    padding: ${({ theme, columnGap, rowGap }) => `${getYGap(theme, rowGap)} ${getXGap(theme, columnGap)}`};
  }
`;
const makeCellWidth = (ratio) => {
    if (!ratio) {
        return 'display: none;';
    }
    return `
    flex-basis: ${ratio * 100}%;
    width: ${ratio * 100}%;
  `;
};
const StyledCell = styled__default.default.div `
  display: flex;
  flex-shrink: 1;
  box-sizing: border-box;

  ${breakpoints.mediaQueryFor('mobile')} {
    ${({ xs }) => makeCellWidth(xs)}
  }
  ${breakpoints.mediaQueryFor('tablet')} {
    ${({ xs, s }) => makeCellWidth(s ?? xs)}
  }
  ${breakpoints.mediaQueryFor('laptop')} {
    ${({ xs, s, m }) => makeCellWidth(m ?? s ?? xs)}
  }
  ${breakpoints.mediaQueryFor('desktop')} {
    ${({ xs, s, m, l }) => makeCellWidth(l ?? m ?? s ?? xs)}
  }

  > div {
    width: 100%;
  }
`;

exports.StyledCell = StyledCell;
exports.StyledWrapper = StyledWrapper;
//# sourceMappingURL=styles.js.map
